module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "support-and-inquiries-media.07b65773.jpg" + "?" + Date.now();